import {FullscreenView} from '@fantasmagames/core/src/screen/fullscreen/FullscreenView';
import {ScreenOrientation} from '@fantasmagames/core/src/screen/fullscreen/FullscreenManager';

export class IOSFullScreenView implements FullscreenView {
	private scrollHand: HTMLElement;
	private scroll: HTMLElement;

	constructor() {
		this.scrollHand = document.createElement('div');
		this.scroll = document.createElement('div');

		this.scrollHand.className = 'scroll-hand-container scroll-hand';
		this.scroll.className = 'scroll';

		document.body.appendChild(this.scrollHand);
		document.body.appendChild(this.scroll);

		// disable scale
		document.addEventListener('gesturestart', (e) => {
			e.preventDefault();
		});

		this.hideScroll();
	}

	public handle(orientation: ScreenOrientation): void {
		if (this.isFullscreen(orientation)) {
			this.hideScroll();
		} else {
			this.showScroll();
		}
	}

	private isFullscreen(orientation: ScreenOrientation): boolean {
		if (orientation === ScreenOrientation.LANDSCAPE) {
			// for safari "window.innerHeight >= screen.width" is enough but for chrome we need to
			// have 20px navbar;
			const barHeight = 44;

			return window.innerHeight + barHeight >= screen.width;
		} else {
			const barHeight = 64;

			return window.innerHeight + barHeight >= screen.height;
		}
	}

	private showScroll(): void {
		this.scrollHand.style.visibility = 'visible';
		this.scroll.style.visibility = 'visible';
	}

	private hideScroll(): void {
		this.scrollHand.style.visibility = 'hidden';
		this.scroll.style.visibility = 'hidden';

		window.scrollBy(0, 0);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/screen/fullscreen/IOSFullScreenView.ts